<template>
  <b-card>
    <city-select />
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Districts/elements/Title.vue'
import CitySelect from '@/views/Admin/Defines/Districts/elements/City.vue'

export default {

  name: 'ItemForm',
  components: {
    BCard,
    TitleName,
    CitySelect,
  },
}
</script>
